


























































































import { KanbanCardFieldModel, DefaultKanbanCardModel } from '@/types/models/kanban';
import { KanbanCardAllFieldConstants } from '@/types/constants/kanban/KanbanCardConstants';
export default {
  name: 'MStoreDefaultKanbanCard',
  props: {
    cardDetails: {
      type: Object as () => DefaultKanbanCardModel,
      required: true
    }
  },
  computed: {
    fieldConfig(this: any) {
      return this.cardDetails?.fields?.reduce((config: any, field: KanbanCardFieldModel) => {
        if (KanbanCardAllFieldConstants.includes(field.fieldName)) {
          config[field.fieldName] = field;
        }
        return config;
      }, {});
    },
    fields(this: any) {
      return this.cardDetails?.fields?.filter(
        (field: KanbanCardFieldModel) => !KanbanCardAllFieldConstants.includes(field.fieldName)
      );
    },
    icons(this: any) {
      return this.cardDetails?.icons?.reduce((config: any, field: any) => {
        if (field?.icon) {
          config[field.fieldName] = field;
        }
        return config;
      }, {});
    },
    cardBodyCss(this: any) {
      return this.cardDetails?.cardStyle;
    },
    cardBorderStyle(this: any) {
      return this.cardDetails?.cardBorderColour ? `kanbanBorder ${this.cardDetails?.cardBorderColour}` : '';
    }
  }
};
